import { t } from "i18next";
import React from "react";
import { useLanguage } from "../../../../hooks/useLanguage";
import { CONCERT, FOOD_COURT, SPORT } from "../../../../constant/constants";
import { safelyParse } from "../../../../utils/utils";

function EventDetailContent({ data = {} }) {
  const { descriptionWithLanguage, conditionWithLanguage } = useLanguage();

  const description = data?.metaData?.[descriptionWithLanguage];
  const condition = data?.metaData?.[conditionWithLanguage];
  const category = data?.category;

  return (
    <div>
      <MatchContent
        title={
          (category === SPORT && t("about_this_match")) ||
          (category === CONCERT && t("about_this_concert")) ||
          (category === FOOD_COURT && t("about_this_event"))
        }
        description={description}
      />
      <div className="mt-6" />
      <MatchTC condition={condition} />
    </div>
  );
}

const MatchTC = ({ condition }) => (
  <div className=" md:px-0">
    <div className="p-6 bg-white border rounded-lg">
      <p className="pb-4 font-bold text-purple-900 text-title-2 sm:text-title-1">
        {t("term_and_condition")}
      </p>
      <div className="text-body-2 text-neutral-600 lg:text-body-1">
        {safelyParse(condition)}
      </div>
    </div>
  </div>
);

const MatchContent = ({ title, description, condition }) => {
  return (
    <div className=" md:px-0">
      <div className="p-6 bg-white border rounded-lg">
        <p className="pb-4 font-bold text-purple-900 text-title-2 sm:text-title-1">
          {title}
        </p>
        <div className="text-body-2 text-neutral-600 lg:text-body-1">
          {/* {title === "Terms and Conditions" ? condition : description} */}
          {safelyParse(
            title === "Terms and Conditions" ? condition : description
          )}
        </div>
      </div>
    </div>
  );
};

export default EventDetailContent;
